// import React, { useState, useEffect } from "react";
// import { BASEURL } from "../../../constants";
// import axios from "axios";

// // Shuffle function to randomize the answers
// const shuffleArray = (array) => {
//     const shuffled = [...array];
//     for (let i = shuffled.length - 1; i > 0; i--) {
//         const j = Math.floor(Math.random() * (i + 1));
//         [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
//     }
//     return shuffled;
// };

// const PreviewMatchColumn = ({ data }) => {
//     const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(null);
//     const [connections, setConnections] = useState([]);
//     const [shuffledAnswers, setShuffledAnswers] = useState([]);
//     const [correctAnswers, setCorrectAnswers] = useState([]);
//     const [isAllCorrect, setIsAllCorrect] = useState(null);
    

//     useEffect(() => {
//         if (data?.answers) {
//             fetchImageUrl(data?.answers);
//             setShuffledAnswers(shuffleArray(data.answers));
//         }
//     }, [data?.answers]);

//     async function fetchImageUrl(answersData) {
//         if (!answersData || !Array.isArray(answersData.answers)) {
//             console.error("answersData.answers is undefined or not an array", answersData);
//             return;
//         }
    
//         const imagesPromiseArray = [];
//         const indexArray = [];
    
//         answersData.answers.forEach((imageObject, index) => {
//             if (imageObject.imageKey) {
//                 const imagePromise = axios.get(`${BASEURL}/api/get-image`, {
//                     params: { imageId: imageObject.imageKey }
//                 });
//                 imagesPromiseArray.push(imagePromise);
//                 indexArray.push(index);
//             }
//         });
    
//         if (imagesPromiseArray.length === 0) {
//             console.warn("No image requests were made");
//             return;
//         }
    
//         try {
//             const promiseResponse = await Promise.all(imagesPromiseArray);
    
//             promiseResponse.forEach((resObj, index) => {
//                 const replaceIndex = indexArray[index];
    
//                 // Ensure answersData.answers exists before modifying it
//                 if (answersData.answers[replaceIndex]) {
//                     answersData.answers[replaceIndex] = {
//                         ...answersData.answers[replaceIndex],
//                         image: resObj.data.dataUrl
//                     };
//                 } else {
//                     console.error(`Invalid index ${replaceIndex} in answersData.answers`);
//                 }
//             });
    
//             setShuffledAnswers(shuffleArray([...answersData.answers])); // Use a spread operator to create a new array
//         } catch (error) {
//             console.error("Error fetching images:", error);
//         }
//     }
    
    

//     // Function to handle question click (Text-to-Speech)
//     const handleQuestionClick = (index) => {
//         setSelectedQuestionIndex(index);
//         const questionText = data?.questions[index].text;

//         const utterance = new SpeechSynthesisUtterance(questionText);
//         const voices = speechSynthesis.getVoices();
//         const selectedVoice = voices.find((voice) => voice.name === "Google UK English Male");

//         if (selectedVoice) {
//             utterance.voice = selectedVoice;
//         }

//         utterance.rate = 1;
//         utterance.pitch = 1;
//         utterance.volume = 1;

//         speechSynthesis.speak(utterance);
//     };

//     const handleAnswerClick = (answerIndex) => {
//         if (selectedQuestionIndex !== null) {
//             // Remove any existing connection that has the selected question or answer
//             const filteredConnections = connections.filter(
//                 conn => conn.question !== selectedQuestionIndex && conn.answer !== answerIndex
//             );

//             // Add the new connection
//             const newConnections = [...filteredConnections, {
//                 question: selectedQuestionIndex,
//                 answer: answerIndex,
//                 isCorrect: data?.questions[selectedQuestionIndex].id === shuffledAnswers[answerIndex].id
//             }];
//             setConnections(newConnections);

//             // Update correct answers
//             console.log(data?.questions[selectedQuestionIndex].id, "question id is")
//             console.log(shuffledAnswers[answerIndex], "answer id")
//             const isCorrect = data?.questions[selectedQuestionIndex].id === shuffledAnswers[answerIndex].id;
//             const updatedCorrectAnswers = isCorrect
//                 ? [...correctAnswers.filter(a => a !== answerIndex), answerIndex]
//                 : correctAnswers.filter(a => a !== answerIndex);

//             setCorrectAnswers(updatedCorrectAnswers);

//             setSelectedQuestionIndex(null);

//             // Check if all connections are correct
//             if (
//                 newConnections.length === data.questions.length &&
//                 newConnections.every((conn) => conn.isCorrect)
//             ) {
//                 setIsAllCorrect(true);
//             } else {
//                 setIsAllCorrect(false);
//             }
//         }
//     };


//     return (
//         <>
//         { data &&
//         <div className="font-sans p-6 bg-gray-100 min-h-screen">
//             <h1 className="text-2xl font-bold mb-4 text-center">Match the Sound to Image</h1>
//             <div className="flex justify-around max-w-4xl mx-auto relative">
//                 {/* Questions (Sounds) */}
//                 <div className="flex flex-col space-y-9">
//                     {data?.questions?.filter(q => q?.text).map((q, qIndex) => (
//                         <button
//                             key={qIndex}
//                             className={`w-20 h-20 flex items-center justify-center rounded-full bg-blue-200 border-2 border-gray-400 shadow-lg transition-all duration-300 ${selectedQuestionIndex === qIndex ? "ring-4 border-gray-400" : ""}`}
//                             onClick={() => handleQuestionClick(qIndex)}
//                         >
//                             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="black" className="size-6">
//                                 <path strokeLinecap="round" strokeLinejoin="round" d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z" />
//                             </svg>
//                         </button>
//                     ))}
//                 </div>

//                 {/* Answers (Images) */}
//                 <div className="flex flex-col space-y-6">
//                     {shuffledAnswers?.filter(ans => ans?.image).map((answer, aIndex) => (
//                         <button
//                             key={aIndex}
//                             className={`w-[90px] h-[90px] flex items-center justify-center rounded-lg transition-all duration-300 border-2 ${correctAnswers.includes(aIndex) ? "border-green-600" :
//                                 connections.some(conn => conn.answer === aIndex && !conn.isCorrect) ? "border-red-600" :
//                                     "border-gray-400"}`}
//                             onClick={() => handleAnswerClick(aIndex)}
//                         >
//                             <img
//                                 src={answer.image}
//                                 alt={`Answer ${aIndex}`}
//                                 className="w-full h-full object-fill rounded-lg"
//                                 onError={(e) => console.log("Image load error for:", e.target.src)}  // Error handling for image loading
//                             />
//                         </button>
//                     ))}
//                 </div>



//                 {/* Draw Lines for Matches */}
//                 <svg className="absolute top-0 left-0 w-full h-full pointer-events-none">
//                     <defs>
//                         <marker id="greenArrow" markerWidth="10" markerHeight="10" refX="6" refY="3" orient="auto" markerUnits="strokeWidth">
//                             <path d="M0,0 L0,6 L9,3 z" fill="green" />
//                         </marker>
//                         <marker id="redArrow" markerWidth="10" markerHeight="10" refX="6" refY="3" orient="auto" markerUnits="strokeWidth">
//                             <path d="M0,0 L0,6 L9,3 z" fill="red" />
//                         </marker>
//                     </defs>
//                     {connections.map((conn, index) => {

//                         const questionY = 40 + conn.question * 110;
//                         const answerY = 40 + conn.answer * 110;
//                         return (
//                             <line
//                                 key={index}
//                                 x1="35%"
//                                 y1={`${questionY}px`}
//                                 x2="65%"
//                                 y2={`${answerY}px`}
//                                 stroke={conn.isCorrect ? "green" : "red"}
//                                 strokeWidth="2"
//                                 strokeDasharray={conn.isCorrect ? "none" : "5,5"}
//                                 markerEnd={conn.isCorrect ? "url(#greenArrow)" : "url(#redArrow)"}
//                             />
//                         );
//                     })}
//                 </svg>
              

//             </div>
//             {connections.length === data?.questions.length && (
//                     <div
//                         className={`mt-8 p-4 text-center text-lg font-bold rounded-md ${isAllCorrect
//                                 ? "bg-green-100 text-green-700 border border-green-400"
//                                 : "bg-red-100 text-red-700 border border-red-400"
//                             }`}
//                     >
//                         {isAllCorrect ? "Correct! Well done!" : "Incorrect. Try again!"}
//                     </div>
//                 )}
//         </div>
// }
//         </>
//     );
// };

// export default PreviewMatchColumn;

import React, { useState, useEffect } from "react";
import { BASEURL } from "../../../constants";
import axios from "axios";

// Shuffle function to randomize the answers
const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};

const PreviewMatchColumn = ({ data }) => {
    const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(null);
    const [connections, setConnections] = useState([]);
    const [shuffledAnswers, setShuffledAnswers] = useState([]);
    const [correctAnswers, setCorrectAnswers] = useState([]);
    const [isAllCorrect, setIsAllCorrect] = useState(null);
    const [filteredQuestions, setFilteredQuestions] = useState([]);
    const [filteredAnswers, setFilteredAnswers] = useState([]);

    useEffect(() => {
        if (data?.questions && data?.answers) {
            // Filter out questions that have no text
            const filteredQuestions = data.questions.filter(q => q.text.trim() !== "");
            setFilteredQuestions(filteredQuestions);

            // Filter out answers that have no image
            const filteredAnswers = data.answers.filter(a => a.imageKey.trim() !== "");
            setFilteredAnswers(filteredAnswers);

            // Fetch image URLs for the filtered answers
            fetchImageUrl(filteredAnswers);
        }
    }, [data?.questions, data?.answers]);

    async function fetchImageUrl(answersData) {
        if (!answersData || !Array.isArray(answersData)) {
            console.error("answersData is undefined or not an array", answersData);
            return;
        }
    
        const imagesPromiseArray = [];
        const indexArray = [];
    
        answersData.forEach((imageObject, index) => {
            if (imageObject.imageKey) {
                const imagePromise = axios.get(`${BASEURL}/api/get-image`, {
                    params: { imageId: imageObject.imageKey }
                });
                imagesPromiseArray.push(imagePromise);
                indexArray.push(index);
            }
        });
    
        if (imagesPromiseArray.length === 0) {
            console.warn("No image requests were made");
            return;
        }
    
        try {
            const promiseResponse = await Promise.all(imagesPromiseArray);
    
            promiseResponse.forEach((resObj, index) => {
                const replaceIndex = indexArray[index];
    
                // Ensure answersData exists before modifying it
                if (answersData[replaceIndex]) {
                    answersData[replaceIndex] = {
                        ...answersData[replaceIndex],
                        image: resObj.data.dataUrl
                    };
                } else {
                    console.error(`Invalid index ${replaceIndex} in answersData`);
                }
            });
    
            setShuffledAnswers(shuffleArray([...answersData])); // Use a spread operator to create a new array
        } catch (error) {
            console.error("Error fetching images:", error);
        }
    }

    // Function to handle question click (Text-to-Speech)
    const handleQuestionClick = (index) => {
        setSelectedQuestionIndex(index);
        const questionText = filteredQuestions[index].text;

        const utterance = new SpeechSynthesisUtterance(questionText);
        const voices = speechSynthesis.getVoices();
        const selectedVoice = voices.find((voice) => voice.name === "Google UK English Male");

        if (selectedVoice) {
            utterance.voice = selectedVoice;
        }

        utterance.rate = 1;
        utterance.pitch = 1;
        utterance.volume = 1;

        speechSynthesis.speak(utterance);
    };

    const handleAnswerClick = (answerIndex) => {
        if (selectedQuestionIndex !== null) {
            // Remove any existing connection that has the selected question or answer
            const filteredConnections = connections.filter(
                conn => conn.question !== selectedQuestionIndex && conn.answer !== answerIndex
            );

            // Add the new connection
            const newConnections = [...filteredConnections, {
                question: selectedQuestionIndex,
                answer: answerIndex,
                isCorrect: filteredQuestions[selectedQuestionIndex].id === shuffledAnswers[answerIndex].id
            }];
            setConnections(newConnections);

            // Update correct answers
            const isCorrect = filteredQuestions[selectedQuestionIndex].id === shuffledAnswers[answerIndex].id;
            const updatedCorrectAnswers = isCorrect
                ? [...correctAnswers.filter(a => a !== answerIndex), answerIndex]
                : correctAnswers.filter(a => a !== answerIndex);

            setCorrectAnswers(updatedCorrectAnswers);

            setSelectedQuestionIndex(null);

            // Check if all connections are correct
            if (
                newConnections.length === filteredQuestions.length &&
                newConnections.every((conn) => conn.isCorrect)
            ) {
                setIsAllCorrect(true);
            } else {
                setIsAllCorrect(false);
            }
        }
    };

    return (
        <>
        { data &&
        <div className="font-sans p-6 bg-gray-100">
            <h1 className="text-2xl font-bold mb-4 text-center">Match the Sound to Image</h1>
            <div className="flex justify-around max-w-4xl mx-auto relative">
                {/* Questions (Sounds) */}
                <div className="flex flex-col space-y-9">
                    {filteredQuestions.map((q, qIndex) => (
                        <button
                            key={qIndex}
                            className={`w-20 h-20 flex items-center justify-center rounded-full bg-blue-200 border-2 border-gray-400 shadow-lg transition-all duration-300 ${selectedQuestionIndex === qIndex ? "ring-4 border-gray-400" : ""}`}
                            onClick={() => handleQuestionClick(qIndex)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="black" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z" />
                            </svg>
                        </button>
                    ))}
                </div>

                {/* Answers (Images) */}
                <div className="flex flex-col space-y-6">
                    {shuffledAnswers.map((answer, aIndex) => (
                        <button
                            key={aIndex}
                            className={`w-[90px] h-[90px] flex items-center justify-center rounded-lg transition-all duration-300 border-2 ${correctAnswers.includes(aIndex) ? "border-green-600" :
                                connections.some(conn => conn.answer === aIndex && !conn.isCorrect) ? "border-red-600" :
                                    "border-gray-400"}`}
                            onClick={() => handleAnswerClick(aIndex)}
                        >
                            <img
                                src={answer.image}
                                alt={`Answer ${aIndex}`}
                                className="w-full h-full object-fill rounded-lg"
                                onError={(e) => console.log("Image load error for:", e.target.src)}  // Error handling for image loading
                            />
                        </button>
                    ))}
                </div>

                {/* Draw Lines for Matches */}
                <svg className="absolute top-0 left-0 w-full h-full pointer-events-none">
                    <defs>
                        <marker id="greenArrow" markerWidth="10" markerHeight="10" refX="6" refY="3" orient="auto" markerUnits="strokeWidth">
                            <path d="M0,0 L0,6 L9,3 z" fill="green" />
                        </marker>
                        <marker id="redArrow" markerWidth="10" markerHeight="10" refX="6" refY="3" orient="auto" markerUnits="strokeWidth">
                            <path d="M0,0 L0,6 L9,3 z" fill="red" />
                        </marker>
                    </defs>
                    {connections.map((conn, index) => {
                        const questionY = 40 + conn.question * 110;
                        const answerY = 40 + conn.answer * 110;
                        return (
                            <line
                                key={index}
                                x1="35%"
                                y1={`${questionY}px`}
                                x2="65%"
                                y2={`${answerY}px`}
                                stroke={conn.isCorrect ? "green" : "red"}
                                strokeWidth="2"
                                strokeDasharray={conn.isCorrect ? "none" : "5,5"}
                                markerEnd={conn.isCorrect ? "url(#greenArrow)" : "url(#redArrow)"}
                            />
                        );
                    })}
                </svg>
            </div>
            {connections.length === filteredQuestions.length && (
                    <div
                        className={`mt-8 p-4 text-center text-lg font-bold rounded-md ${isAllCorrect
                                ? "bg-green-100 text-green-700 border border-green-400"
                                : "bg-red-100 text-red-700 border border-red-400"
                            }`}
                    >
                        {isAllCorrect ? "Correct! Well done!" : "Incorrect. Try again!"}
                    </div>
                )}
        </div>
}
        </>
    );
};

export default PreviewMatchColumn;
